var map = {
  "./cs.json": [
    "P21",
    [
      "1y"
    ]
  ],
  "./en.json": [
    "at",
    [
      "0j"
    ]
  ],
  "./pl.json": [
    "K7i",
    [
      "wk"
    ]
  ],
  "./ru.json": [
    "jD",
    [
      "5w"
    ]
  ],
  "./tr.json": [
    "yF",
    [
      "wp"
    ]
  ],
  "./ja.json": [
    "jmp",
    [
      "tl"
    ]
  ],
  "./zh.json": [
    "shG",
    [
      23
    ]
  ],
  "./pt-br.json": [
    "Sk",
    [
      "g9l"
    ]
  ],
  "./de.json": [
    "nMI",
    [
      "d6t"
    ]
  ],
  "./es.json": [
    "c3U",
    [
      "m"
    ]
  ],
  "./fr.json": [
    "Szn",
    [
      "kd8"
    ]
  ],
  "./it.json": [
    "fIb",
    [
      19
    ]
  ],
  "./ko.json": [
    "cd",
    [
      "ma"
    ]
  ],
  "./pt.json": [
    "Zjc",
    [
      "bnv"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Sf";
module.exports = __rspack_async_context;
